const tradeFairManageRoutes = (prop) => [
    {
      path: 'receive-application',
      name: prop + '.receive_application',
      meta: { auth: true, name: 'Editable' },
      component: () => import('../pages/app-manage/ReceiveList.vue')
    },
    {
      path: 'approve-application',
      name: prop + '.approve_application',
      meta: { auth: true, name: 'Editable' },
      component: () => import('../pages/app-manage/ApproveList.vue')
    },
    {
      path: 'reject-application',
      name: prop + '.approve_application',
      meta: { auth: true, name: 'Editable' },
      component: () => import('../pages/app-manage/RejectedList.vue')
    },
    {
      path: 'forward-application',
      name: prop + '.forward_application',
      meta: { auth: true, name: 'Editable' },
      component: () => import('../pages/app-manage/ForwardList.vue')
    },
    {
      path: 'approved-fair-report',
      name: prop + '.approved_fair_report',
      meta: { auth: true, name: 'Editable' },
      component: () => import('../pages/report/ApproveFairReport.vue')
    },
    {
      path: 'revenue-report',
      name: prop + '.revenue_report',
      meta: { auth: true, name: 'Editable' },
      component: () => import('../pages/report/MonthlyRevenueCollectionReport.vue')
    },
    {
      path: 'fair-report',
      name: prop + '.fair_report',
      meta: { auth: true, name: 'Editable' },
      component: () => import('../pages/report/fair-report/List.vue')
    },
    {
      path: 'payment-report',
      name: prop + '.payment_report',
      meta: { auth: true, name: 'Editable' },
      component: () => import('../pages/report/payment-report/List.vue')
    },
    {
      path: 'document-signatory',
      name: prop + '.document_signatory',
      meta: { auth: true, name: 'Editable' },
      component: () => import('../pages/document-signatory/List.vue')
    }
  ]
  const routes = [
    {
      path: '/trade-fair-service/ditf/division-fair-application-management',
      name: 'trade_fair_service.division_fair_application_management',
      component: () => import('@/layouts/TradeFairServiceLayout.vue'),
      meta: { auth: true },
      children: tradeFairManageRoutes('trade_fair_service.division_fair_application_management')
    }
  ]
  export default routes
